export default {
  MEMORY: 0,
  LOCAL: 1,
  SESSION: 2
};



// WEBPACK FOOTER //
// ./node_modules/@aofl/cache-manager/src/CacheTypeEnumerate/index.js